module.exports = __webpack_public_path__ + "img/google-icon.96c6026f.png";